import React, { useMemo } from 'react';

import {
    NativeSyntheticEvent,
    Platform,
    Pressable,
    TextInputSubmitEditingEventData,
    View,
} from 'react-native';

import { useTranslation } from 'react-i18next';

import { LANGUAGE_KEYS } from 'config/languageKeys';
import gStyles from 'config/styles';
import { SEARCH_CANCEL_BUTTON_ID } from 'config/testID';

import { isWeb } from 'utils/responsiveness';

import Text, { ETextCategory, ETextColor } from 'components/Text';

import SearchInput from '../SearchInput';
import styles from './styles';

type Props = {
    searchText: string;
    onCancelPress(): void;
    onSubmitEditing(
        e: NativeSyntheticEvent<TextInputSubmitEditingEventData>,
    ): void;
    onChangeSearchText(text: string): void;
};

const {
    CANCEL_BUTTON,
    ACCESSIBILITY: {
        ACCESSIBILITY_GENERAL_TAPP_TWICE,
        ACCESSIBILITY_GENERAL_TAPP_TWICE_WEB,
    },
} = LANGUAGE_KEYS;

function SearchHeader({
    searchText,
    onChangeSearchText,
    onCancelPress,
    onSubmitEditing,
}: Props) {
    const { t } = useTranslation();

    const accessibilityLabel = useMemo(
        () =>
            `${t(CANCEL_BUTTON)} ${
                isWeb ? t(ACCESSIBILITY_GENERAL_TAPP_TWICE_WEB) : ''
            }`,
        [t],
    );

    return (
        <View style={styles.container}>
            <View style={gStyles.flex}>
                <SearchInput
                    searchText={searchText}
                    onChangeSearchText={onChangeSearchText}
                    onSubmitEditing={onSubmitEditing}
                />
            </View>
            <Pressable
                testID={SEARCH_CANCEL_BUTTON_ID}
                style={styles.cancel}
                onPress={onCancelPress}
                accessibilityRole="button"
                accessibilityLabel={accessibilityLabel}
                {...(Platform.OS === 'ios' && {
                    accessibilityHint: t(ACCESSIBILITY_GENERAL_TAPP_TWICE),
                })}
            >
                <Text
                    category={ETextCategory.body1}
                    color={ETextColor.neutral}
                    numberOfLines={1}
                >
                    {t(CANCEL_BUTTON)}
                </Text>
            </Pressable>
        </View>
    );
}

export default SearchHeader;
